import { styled } from "@mui/material";

export const TextFieldLabel = styled("label")(({ theme }) => ({
  display: "inline-flex",
  flexDirection: "column",
  fontSize: theme.typography.caption.fontSize,
  gap: theme.spacing(1),
  transform: "none",
}));
